var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var FacilitiesComponent = /** @class */ (function (_super) {
    __extends(FacilitiesComponent, _super);
    function FacilitiesComponent(injector, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.translateService = translateService;
        _this.reasons = [];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    FacilitiesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setTitle('Facilitățile proiectului Romanescu Park Residence');
        this.setMetaDescription("\n      Printre facilit\u0103\u021Bile proiectului Romanescu Park se num\u0103r\u0103: loca\u021Bie privilegiat\u0103, aproape de centru\n      \u0219i natur\u0103, finisaje de calitate, parcare pentru locatari \u0219i vizitatori, spa\u021Bii de joac\u0103 pentru copii,\n      spa\u021Bii verzi, apropierea de sta\u021Bii de transport \u00EEn comun.\n    ");
        this.reasons = this.getReasons();
        this.subscription.add(this.translateService.onLangChange
            .subscribe(function () { return _this.reasons = _this.getReasons(); }));
    };
    FacilitiesComponent.prototype.getReasons = function () {
        var reasons = [];
        var _loop_1 = function (i) {
            var reason = {
                title: '',
                content: '',
                image: {
                    url: ''
                }
            };
            this_1.translateSubscription.add(this_1.translateService.get('lifestyle_items.' + i + '.title')
                .subscribe(function (translatedString) {
                reason.title = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('lifestyle_items.' + i + '.content')
                .subscribe(function (translatedString) {
                reason.content = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('lifestyle_items.' + i + '.image.url')
                .subscribe(function (translatedString) {
                reason.image.url = translatedString;
            }));
            reasons.push(reason);
        };
        var this_1 = this;
        for (var i = 0; i <= 5; i++) {
            _loop_1(i);
        }
        return reasons;
    };
    return FacilitiesComponent;
}(SeoAwareBaseComponent));
export { FacilitiesComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/facilities.component.ts.pre-build-optimizer.js